//  MBQ NOV 2025 RESTYLING UX selection 
import React from 'react'
import { AuthConsumer } from 'react-check-auth'
import { ContentConsumer } from '../../../language'
import { useFeature } from '../../../contexts/Feature/FeatureContext'
import { USER_PREMIUM_ROLES } from '../../../globals/userRoles'
import UX_TYPE from '../../../globals/uxType'
import { Alert, Button } from 'reactstrap'
import envSettings from '../../../globals/envSettings'
import axios from 'axios'
import axiosConfig from '../../../config/axios'

import { parseToReactElement } from 'utils/html'

const UXSelector = () => {
  const { oldApp: oldAppOn, appVersions: appVersionsOn } = useFeature()

  const changeUxSelection = e => {
    e.preventDefault()
    return axios.create(axiosConfig)
      .put(`/user/ux/${UX_TYPE.NEW_APP.toLowerCase()}`)
      .then(() => {
        window.location.href = envSettings.NEW_APP_BASEURL
      })
      .catch(error => {
        console.error('[UX-PREFERENCE] response KO ', error.toString())
      })
  }

  return (
    oldAppOn && appVersionsOn ?
      (
        <AuthConsumer>
          {({ userInfo }) => (
            userInfo && USER_PREMIUM_ROLES.includes(userInfo.role) ?
              (
                <ContentConsumer>
                  {({ content }) => (content && (
                    <Alert className='text-center mb-0 w-100 ux-selector'>
                      <div>{parseToReactElement(content.header.uxselector_text)}</div>
                      <Button
                        className='mt-0 mb-3 mb-md-0'
                        onClick={
                          e => { changeUxSelection(e) }
                        }
                      >
                        {content.header.uxselector_button}
                      </Button>
                    </Alert>)
                  )}
                </ContentConsumer>
              )
              :
              null
          )}
        </AuthConsumer>
      )
      :
      (null)
  )
}

export default UXSelector